import { UIPanel, UIDiv } from '@/components/assets/js/libs/ui.js';

function MenubarLogo() {

	const container = new UIPanel();
	container.setClass('menu');

	const logoLink = document.createElement('a');
	logoLink.href = 'https://www.stni.co.kr/';
	logoLink.target = '_blank'; 
	

	const logoimg = document.createElement('img');
	

	
	// 전역 config 사용 불가 시, fallback 추가 가능
	const currentTheme = window.editor?.config.getKey('settings/theme') || 'Light';

	// 이미지 경로 설정
	if (currentTheme === 'Dark') {
		logoimg.src = 'images/brand_Black.png';
	} 
	else if(currentTheme === 'Light') {
		logoimg.src = 'images/brand_white.png';
	}

	window.themeLogoImage = logoimg;

	//logoimg.src = 'images/brand_Black.png';
	logoimg.width = 200.0;
	logoimg.style.marginLeft = '10px'; 
	logoimg.style.marginTop = '5px'; 

	logoLink.appendChild(logoimg);

	const logo = new UIDiv();	
	logo.dom.appendChild(logoLink);	
	

	container.add(logo);

	return container;
}

export { MenubarLogo };
